const STATUS_CODE = {
    UNKNOWN: -1,
    PARSE_JSON: -501,
    SUCCEED: 200
};

export {
    STATUS_CODE
}


// WEBPACK FOOTER //
// ./src/api/conf/base.js